import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import { AsyncTypeahead, Highlighter } from 'react-bootstrap-typeahead';
import axios from 'axios';

export default class SearchMemberTypeAhead extends Component {

    constructor() {
        super();

        this.configurations = new Configurations();

        this.state = {
            isLoading: false,
            options: [],
        };

    }

    removeDivAsyncTypeahead() {
        document.querySelectorAll("div.rbt-input-hint").forEach(e => e.parentNode.removeChild(e));
    }

    render() {
        return (
            <form className="form-header" action="" method="POST">
                <AsyncTypeahead
                    id="mainSearch"
                    isLoading={this.state.isLoading}
                    className="ebs-typeahead w-100"
                    disabled={this.props.disableInput}
                    onChange={(s) => {
                        if ((this.props.coordPeriodicos || this.props.beneficiarios) && s && s.length > 0 && (s[0].type === 1 || s[0].type === 2 || s[0].type === 3)) {
                            this.props.getMembroSelecionado(s[0])
                        }
                    }}
                    labelKey={(option) => {
                        if (option) {
                            switch (option.type) {
                                case 1:
                                    return `M${option.codMembro.toString()}`;
                                case 3:
                                    return `C${option.cpf.toString()}`;
                                default:
                                    return option.nome;
                            }
                        } else {
                            return option;
                        }
                    }
                    }
                    renderMenuItemChildren={(option, props, idx) => {
                        return (
                            <div className="d-flex align-items-center border-bottom">
                                <Highlighter search={props.text}>
                                    {option.nome}
                                </Highlighter>
                                &nbsp;<small>(
                                    <Highlighter search={props.text.substr(1, props.text.length)}>
                                        {option.codMembro ? option.codMembro.toString() : ''}
                                    </Highlighter>)</small>
                                &nbsp;<span className="badge badge-info">{option.divisao}</span>
                                &nbsp; - {option.coordenadoria}
                            </div>
                        )
                    }}
                    delay={400}
                    emptyLabel="Nenhum resultado encontrado"
                    searchText="Procurando..."
                    promptText="Digite para procurar..."
                    minLength={2}
                    placeholder={this.props.beneficiarios ? "" : `Insira o ${(this.props.coordPeriodicos) ? 'nome' : 'número do pedido'} ou código de membro...`}
                    onSearch={query => {
                        this.setState({ isLoading: true });
                        axios.get(this.configurations.apiBasePath + `/busca?query=${query}`)
                            .then(resp => {
                                if (resp.data && (resp.data.orders || resp.data.users)) {
                                    this.setState({
                                        isLoading: false,
                                        options: resp.data.orders.length > 0 ? resp.data.orders : resp.data.users
                                    });
                                }
                            });
                    }}
                    options={this.state.options}
                    onFocus={() => this.removeDivAsyncTypeahead()}
                />
            </form>
        )
    }
}